import { IAnalyticsTracking } from './interfaces/analyticsInterfaces'
import { NavigationMenu } from './trackEvents/navigationMenu'
import { Claim } from './trackEvents/claim'
import { Drop } from './trackEvents/drop'
import { Generics } from './trackEvents/generics'
import { Secrets } from './trackEvents/secrets'
import { Websites } from './trackEvents/websites'

export const analyticsTracking: IAnalyticsTracking = {
  claim: Claim,
  drop: Drop,
  websites: Websites,
  secrets: Secrets,
  navigation: NavigationMenu,
  generics: Generics,
}
